import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-d48a293a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TumiBackLogin" }
const _hoisted_2 = { class: "TumiLogin" }
const _hoisted_3 = { class: "TumiForm" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "LogoTumi",
  class: "TumiLogoLola"
}, null, -1))
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-white mb-4" }, "You can click on the button to download the files.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", null, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("button", {
              class: "btn btn-info",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.Download && _ctx.Download(...args)))
            }, "Download files")
          ])
        ])
      ])
    ])
  ]))
}